/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var franchiseeListColumns = [{
  name: 'Номер',
  render: function render(franchisee) {
    return ___EmotionJSX(Link, {
      to: {
        pathname: "franchises/details/".concat(franchisee === null || franchisee === void 0 ? void 0 : franchisee.id),
        state: {
          franchisee: franchisee
        }
      }
    }, franchisee === null || franchisee === void 0 ? void 0 : franchisee.id);
  },
  width: '110px'
}, {
  name: 'Име',
  value: 'name'
}, {
  name: 'Адрес',
  value: 'address'
}, {
  name: 'Лихвен проц.',
  render: function render(_ref) {
    var credit_interest_percent = _ref.credit_interest_percent;
    return ___EmotionJSX("span", null, credit_interest_percent, "%");
  }
}, {
  name: 'Комисионна',
  render: function render(_ref2) {
    var royalties_percent = _ref2.royalties_percent;
    return ___EmotionJSX("span", null, royalties_percent, "%");
  }
}, {
  name: 'Действие',
  render: function render(franchisee) {
    return ___EmotionJSX(TableActions, {
      mainAction: {
        linkTo: {
          pathname: "/franchises/details/".concat(franchisee === null || franchisee === void 0 ? void 0 : franchisee.id),
          state: {
            franchisee: franchisee
          }
        },
        leftIcon: {
          iconName: 'la la-info',
          size: 20
        },
        css: detailsBtn
      }
    });
  },
  width: '90px'
}];